<template>
  <div v-if="contact">
    {{ contactName }} |
    {{ description }}
    <AppShowCountry :country="country" :show-ioc="false" />
    {{ registryCode }}
  </div>
</template>
<script>
import { defineComponent, computed, toRef } from "vue";
import gql from "fraql";
import AppShowCountry from "./AppShowCountry.vue";

export default defineComponent({
  name: "AppShowContactName",
  components: { AppShowCountry },
  props: {
    contact: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const contact = toRef(props, "contact");
    const contactName = computed(() => {
      switch (contact.value.contactType) {
        case "PERSON":
          return contact.value.name;
        case "ORGANISATION":
          return contact.value.organisationName;
        default:
          return "";
      }
    });
    const description = computed(() => {
      return contact.value.contactType == "ORGANISATION" &&
        contact.value.description
        ? contact.value.description + " | "
        : "";
    });

    const registryCode = computed(() => {
      const code = String(contact.value.registryCode);
      return contact.value.registryCode ? ` | ${code}` : "";
    });

    const country = computed(() => {
      switch (contact.value.contactType) {
        case "ORGANISATION":
          return contact.value.registryCountry || contact.value.addressCountry;
        default:
          return contact.value.addressCountry;
      }
    });

    return {
      country,
      registryCode,
      contactName,
      description
    };
  },
  fragments: {
    contactFields: gql`
      fragment _ on Contact {
        id
        name
        organisationName
        contactType
        addressCountryId
        addressCountry @client {
          ${AppShowCountry.fragments.country}
        }
        registryCountryId
        registryCountry @client {
          ${AppShowCountry.fragments.country}
        }
        registryCode
        description
      }
    `
  }
});
</script>
